// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__zF5oQ","legacyBtn":"MutateMid_legacyBtn__l8oKB"};